<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-tabs v-model="activeName">
        <el-tab-pane label="区域" name="region">
          <region v-if="activeName === 'region'"></region>
        </el-tab-pane>
        <el-tab-pane label="行业" name="industry">
          <industry v-if="activeName === 'industry'"></industry>
        </el-tab-pane>
        <el-tab-pane label="企业注册类型" name="register">
          <register v-if="activeName === 'register'"></register>
        </el-tab-pane>
        <el-tab-pane label="企业" name="enterprise">
          <enterprise v-if="activeName === 'enterprise'"></enterprise>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import enterprise from "./enterprise";
import industry from "./industry";
import region from "./region";
import register from "./register";
export default {
  components: {
    enterprise,
    industry,
    region,
    register,
  },
  data() {
    return {
      activeName: "region",
    };
  },
  methods: {},
};
</script>
<style>
@import url("../../../assets/styles/elementUI.css");
</style>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>